import { blue, grey } from "@mui/material/colors";
import { extendTheme as extendJoyTheme } from "@mui/joy/styles";
import {
  experimental_extendTheme as extendMuiTheme,
  responsiveFontSizes,
} from "@mui/material/styles";
import { deepmerge } from "@mui/utils";

export const getMuiTheme = () => {
  const muiTheme = extendMuiTheme({
    // palette: {
    //   primary: blue,
    //   secondary: amber,
    // },
    typography: {
      h4: {
        fontFamily: "turnip, serif",
      },
      button: {
        textTransform: "none",
        fontSize: 14,
      },
    },
  });

  return responsiveFontSizes(muiTheme);
};

export const getJoyTheme = () => {
  const muiTheme = getMuiTheme();
  return extendJoyTheme({
    // This is required to point to `var(--mui-*)` because we are using `CssVarsProvider` from Material UI.
    cssVarPrefix: "mui",
    colorSchemes: {
      light: {
        palette: {
          primary: {
            ...blue,
            solidColor: "var(--mui-palette-primary-contrastText)",
            solidBg: "var(--mui-palette-primary-main)",
            solidHoverBg: "var(--mui-palette-primary-dark)",
            plainColor: "var(--mui-palette-primary-main)",
            plainHoverBg:
              "rgba(var(--mui-palette-primary-mainChannel) / var(--mui-palette-action-hoverOpacity))",
            plainActiveBg: "rgba(var(--mui-palette-primary-mainChannel) / 0.3)",
            outlinedBorder:
              "rgba(var(--mui-palette-primary-mainChannel) / 0.5)",
            outlinedColor: "var(--mui-palette-primary-main)",
            outlinedHoverBg:
              "rgba(var(--mui-palette-primary-mainChannel) / var(--mui-palette-action-hoverOpacity))",
            outlinedHoverBorder: "var(--mui-palette-primary-main)",
            outlinedActiveBg:
              "rgba(var(--mui-palette-primary-mainChannel) / 0.3)",
          },
          neutral: {
            ...grey,
          },
          // Do the same for the `danger`, `info`, `success`, and `warning` palettes,
          divider: "var(--mui-palette-divider)",
          text: {
            tertiary: "rgba(0 0 0 / 0.56)",
          },
        },
      },
      // Do the same for dark mode
      // dark: { ... }
    },
    fontFamily: {
      display: '"ebony","Helvetica","Arial",sans-serif',
      body: '"ebony","Helvetica","Arial",sans-serif',
    },
    shadow: {
      xs: `var(--mui-shadowRing), ${muiTheme.shadows[1]}`,
      sm: `var(--mui-shadowRing), ${muiTheme.shadows[2]}`,
      md: `var(--mui-shadowRing), ${muiTheme.shadows[4]}`,
      lg: `var(--mui-shadowRing), ${muiTheme.shadows[8]}`,
      xl: `var(--mui-shadowRing), ${muiTheme.shadows[12]}`,
    },
  });
};

export const getTheme = () => {
  const muiTheme = getMuiTheme();
  const joyTheme = getJoyTheme();
  const theme = deepmerge(joyTheme, muiTheme);

  return theme;
};
